var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row-dots",class:_vm.clazz},[_c('label',{staticClass:"row-title",class:_vm.clazzRowTitle},[_vm._v(_vm._s(_vm.textRowTitle))]),_c('p',{staticClass:"row-text",class:_vm.clazzRowText},[_vm._v(_vm._s(_vm.textRow))])])
}
var staticRenderFns = []

export { render, staticRenderFns }